// import React, { useState } from "react";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';
// import './Contact.css';

// const Contact = () => {
//   const [phone, setPhone] = useState('');

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Add your validation or form submission logic here
//     if (!phone) {
//       alert('Please enter a phone number.');
//     } else {
//       alert(`Phone number entered: ${phone}`);
//     }
//   };

//   return (
//     <div className="contact-container">
//       <div className="map-section">
//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.210488950282!2d73.06793227554174!3d33.63188397331822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89128941fe348bf9%3A0xceeb80b39cf9f5ad!2sProgrammers%20Lab_Web%20Designing%20Web%20Development%20Course%2C%20Graphic%20%26%20UI%2FUX%20Designing%20Course%2C%20Mobile%20App%2C%20C%2B%2B%20Islamabad%2C%20Rawalpindi!5e1!3m2!1sen!2s!4v1723704242447!5m2!1sen!2s"
//           className="map"
//           allowFullScreen=""
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//           title="Location Map"
//         ></iframe>
//       </div>
//       <div className="contact-form-section animated">
//         <h2 style={{ marginLeft: '10px' }}>Contact Us</h2>
//         <div className="contact-form">
//           <h3>Get in Touch</h3>
//           <form onSubmit={handleSubmit}>
//             <label htmlFor="name">Name:</label>
//             <input type="text" id="name" name="name" placeholder="Your Name" required />
            
//             <label htmlFor="email">Email:</label>
//             <input type="email" id="email" name="email" placeholder="Your Email" required />
            
//             <label htmlFor="phone">Phone:</label>
//             <PhoneInput
//               id="phone"
//               defaultCountry="US"
//               value={phone}
//               onChange={setPhone}
//               placeholder="Phone Number"
//               required
//             />
            
//             <label htmlFor="subject">Subject:</label>
//             <input type="text" id="subject" name="subject" placeholder="Subject" required />
            
//             <label htmlFor="message">Message:</label>
//             <textarea id="message" name="message" placeholder="Your Message" required></textarea>
            
//             <button type="submit" className="site-btn">Send Message</button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { db, collection, addDoc, serverTimestamp } from './firebase'; // Import Firestore functions
import './Contact.css';

const Contact = () => {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone || !name || !email || !subject || !message) {
      setError('Please fill in all fields.');
      return;
    }

    try {
      await addDoc(collection(db, 'contacts'), {
        name,
        email,
        phone,
        subject,
        message,
        timestamp: serverTimestamp()
      });
      alert('Message sent successfully!');
      setError('');
    } catch (err) {
      console.error("Error adding document: ", err);
      setError('There was an error sending your message. Please try again.');
    }

    // Clear the form
    setName('');
    setEmail('');
    setPhone('');
    setSubject('');
    setMessage('');
  };

  return (
    <div className="contact-container">
      <div className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.210488950282!2d73.06793227554174!3d33.63188397331822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89128941fe348bf9%3A0xceeb80b39cf9f5ad!2sProgrammers%20Lab_Web%20Designing%20Web%20Development%20Course%2C%20Graphic%20%26%20UI%2FUX%20Designing%20Course%2C%20Mobile%20App%2C%20C%2B%2B%20Islamabad%2C%20Rawalpindi!5e1!3m2!1sen!2s!4v1723704242447!5m2!1sen!2s"
          className="map"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Location Map"
        ></iframe>
      </div>
      <div className="contact-form-section animated">
        <h2 style={{ marginLeft: '10px' }}>Contact Us</h2>
        <div className="contact-form">
          <h3>Get in Touch</h3>
          <form onSubmit={handleSubmit}>
            {error && <p className="error-message">{error}</p>}
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            
            <label htmlFor="phone">Phone:</label>
            <PhoneInput
              id="phone"
              defaultCountry="US"
              value={phone}
              onChange={setPhone}
              placeholder="Phone Number"
              required
            />
            
            <label htmlFor="subject">Subject:</label>
            <input
              type="text"
              id="subject"
              name="subject"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
            
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
            
            <button type="submit" className="site-btn">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
